import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface CategoryDeletionModalProps {
    show: boolean;
    onHide: () => void;
    categoryName: string;
    canDelete: boolean;
    buildingUsage?: {
        count: number;
        buildingNames: string[];
    };
    childCategories?: {
        count: number;
        childNames: string[];
    };
    onConfirmDelete?: () => void;
}

const CategoryDeletionModal: React.FC<CategoryDeletionModalProps> = ({
    show,
    onHide,
    categoryName,
    canDelete,
    buildingUsage,
    childCategories,
    onConfirmDelete,
}) => {
    const handleConfirm = () => {
        if (onConfirmDelete) {
            onConfirmDelete();
        }
        onHide();
    };

    if (!canDelete) {
        // Show blocking information
        return (
            <Modal show={show} onHide={onHide} size="lg">
                <Modal.Header closeButton style={{ backgroundColor: '#fff3cd', borderBottom: '1px solid #ffc107' }}>
                    <Modal.Title style={{ color: '#856404', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '24px' }}>⚠️</span>
                        Kan inte ta bort kategori
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ fontSize: '16px', marginBottom: '20px' }}>
                        Kategorin <strong>"{categoryName}"</strong> kan inte tas bort eftersom:
                    </p>

                    {buildingUsage && buildingUsage.count > 0 && (
                        <div style={{ marginBottom: '25px' }}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '12px',
                                    padding: '12px',
                                    backgroundColor: '#e7f3ff',
                                    borderLeft: '4px solid #2196F3',
                                    borderRadius: '4px',
                                }}
                            >
                                <span style={{ fontSize: '24px' }}>📋</span>
                                <span style={{ fontSize: '16px', fontWeight: 600 }}>
                                    {buildingUsage.count} {buildingUsage.count === 1 ? 'byggnad använder' : 'byggnader använder'} denna
                                    kategori
                                </span>
                            </div>
                            <ul style={{ marginLeft: '20px', marginBottom: '0' }}>
                                {buildingUsage.buildingNames.slice(0, 10).map((name, index) => (
                                    <li key={index} style={{ marginBottom: '6px', fontSize: '14px' }}>
                                        {name}
                                    </li>
                                ))}
                                {buildingUsage.buildingNames.length > 10 && (
                                    <li style={{ color: '#666', fontStyle: 'italic', fontSize: '14px' }}>
                                        ... och {buildingUsage.buildingNames.length - 10} fler
                                    </li>
                                )}
                            </ul>
                        </div>
                    )}

                    {childCategories && childCategories.count > 0 && (
                        <div style={{ marginBottom: '20px' }}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '12px',
                                    padding: '12px',
                                    backgroundColor: '#fff3e0',
                                    borderLeft: '4px solid #FF9800',
                                    borderRadius: '4px',
                                }}
                            >
                                <span style={{ fontSize: '24px' }}>🗂️</span>
                                <span style={{ fontSize: '16px', fontWeight: 600 }}>
                                    {childCategories.count} {childCategories.count === 1 ? 'underkategori har' : 'underkategorier har'} denna
                                    som överordnad
                                </span>
                            </div>
                            <ul style={{ marginLeft: '20px', marginBottom: '0' }}>
                                {childCategories.childNames.slice(0, 10).map((name, index) => (
                                    <li key={index} style={{ marginBottom: '6px', fontSize: '14px' }}>
                                        {name}
                                    </li>
                                ))}
                                {childCategories.childNames.length > 10 && (
                                    <li style={{ color: '#666', fontStyle: 'italic', fontSize: '14px' }}>
                                        ... och {childCategories.childNames.length - 10} fler
                                    </li>
                                )}
                            </ul>
                        </div>
                    )}

                    <div
                        style={{
                            padding: '15px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '4px',
                            marginTop: '20px',
                        }}
                    >
                        <p style={{ margin: 0, fontSize: '14px', color: '#495057' }}>
                            <strong>Så här går du vidare:</strong> Ta bort eller flytta dessa byggnader och underkategorier
                            först innan kategorin kan raderas.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={onHide}>
                        OK, jag förstår
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    // Show confirmation dialog
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Bekräfta borttagning</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ fontSize: '16px' }}>
                    Är du säker på att du vill ta bort kategorin <strong>"{categoryName}"</strong>?
                </p>
                <p style={{ fontSize: '14px', color: '#666', marginBottom: 0 }}>
                    Denna åtgärd kan inte ångras.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Avbryt
                </Button>
                <Button variant="danger" onClick={handleConfirm}>
                    Ta bort
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CategoryDeletionModal;

